import { useParams, Link } from "react-router-dom";
import { FaArrowLeft, FaGithub } from "react-icons/fa";
import { projects } from "../data";
import { MdLiveTv } from "react-icons/md";
import MainLayout from "../layouts/MainLayout";
import NotFound from "./NotFound";

const Detail = () => {
    const { id } = useParams();
    const project = projects.find((p) => p.id === Number(id));

    if (!project) return <NotFound />

    return (
        <MainLayout>
            <div className="relative w-full h-56 sm:h-72 md:h-[34rem]">
                <img src={project.images[0].url} alt={project.images[0].alt} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/40">
                    <div className="w-full max-w-7xl mx-auto mt-6 px-4 pointer-events-auto">
                        <Link
                            to="/#projects"
                            className="w-fit bg-white px-4 py-1 hover:opacity-95 text-black font-semibold border border-black transition shadow-default active:translate-x-[2px] active:translate-y-[2px] active:shadow-none flex items-center gap-2 text-sm sm:text-base hover:-translate-y-1"
                        >
                            <FaArrowLeft size={12} />
                            Back to Projects
                        </Link>
                    </div>
                </div>
            </div>

            {/* title */}
            <div className="w-full bg-primary">
                <div className="max-w-7xl mx-auto px-4 py-10 sm:py-14 flex flex-col gap-3">
                    <div className="flex flex-wrap gap-2">
                        {project.tech.map((tech, index) => (
                            <div key={index} className="bg-white text-black border-2 border-black px-3 py-1 text-sm sm:text-base">{tech}</div>
                        ))}
                    </div>
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white break-words">{project.title}</h1>
                    <p className="text-base sm:text-lg text-white">{project.description}</p>
                </div>
            </div>

            {/* OVERVIEW + CHALLENGE + SOLUTION + OUTCOME */}
            <div className="px-4 sm:px-6 md:px-12 lg:px-20 py-10 sm:py-16 border-b-2 border-black">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[0.5fr_2fr] gap-10 lg:gap-16">

                    {/* Sidebar nav */}
                    <div className="hidden lg:block">
                        <div className="sticky top-28 space-y-4">
                            {['Overview', 'Challenge', 'Solution', 'Outcome'].map((s) => (
                                <a
                                    key={s}
                                    href={`#${s.toLowerCase()}`}
                                    className="block px-4 py-1 hover:underline text-sm font-medium w-fit"
                                >
                                    {s}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-14">
                        {[
                            { id: 'overview', label: 'Overview', text: project.overview },
                            { id: 'challenge', label: 'The Challenge', text: project.challenge },
                            { id: 'solution', label: 'The Solution', text: project.solution },
                            { id: 'outcome', label: 'The Outcome', text: project.outcome },
                        ].map((item, index) => (
                            <div key={index} id={item.id} className="scroll-mt-28">
                                <div
                                    className="inline-block px-4 py-1 border-2 border-black font-mono text-xs tracking-widest mb-4 bg-primary text-white"
                                    style={{ backgroundColor: project.color, fontFamily: "'DM Mono', monospace" }}
                                >
                                    {item.label.toUpperCase()}
                                </div>
                                <p className="text-base leading-relaxed">{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* screenshot */}
            <div className="bg-black w-full py-10 sm:py-14">
                <div className="max-w-7xl mx-auto px-4">
                    <h2 className="text-white font-bold text-4xl">SCREENSHOT</h2>
                    <div className="overflow-x-auto flex gap-4 mt-6 pb-4 -mx-1 px-1 snap-x snap-mandatory">
                        {project.images.slice(1).map((image, index) => (
                            <div key={index} className="flex-shrink-0 w-[82vw] max-w-[24rem] snap-start">
                                <img src={image.url} alt={image.alt} className="w-full border border-primary" />
                                <p className="text-white/70 mt-2 text-sm">{image.alt}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* screenshot */}
            <div className="bg-primary w-full py-10 sm:py-14">
                <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
                    <h2 className="text-white font-bold text-3xl sm:text-4xl">LET'S SEE</h2>
                    <div className="flex flex-wrap gap-3 sm:gap-4">
                        {/* <a href="#projects" className="bg-black px-5 py-3 sm:px-8 sm:py-4 hover:opacity-95 text-white font-semibold border border-black transition shadow-default active:translate-x-[2px] active:translate-y-[2px] active:shadow-none flex items-center gap-2 text-sm sm:text-base hover:-translate-y-1">
                            <MdLiveTv size={20} />
                            Live
                            </a> */}
                        <button disabled className="bg-black px-5 py-3 sm:px-8 sm:py-4 text-white/75 font-semibold border border-black transition shadow-default flex items-center gap-2 text-sm sm:text-base">
                            <MdLiveTv size={20} />
                            Live
                        </button>
                        <a href={project.link} target="_blank" rel="noreferrer" className="bg-white px-5 py-3 sm:px-8 sm:py-4 hover:opacity-95 text-black font-semibold border border-black transition shadow-default active:translate-x-[2px] active:translate-y-[2px] active:shadow-none flex items-center gap-2 text-sm sm:text-base hover:-translate-y-1">
                            <FaGithub size={20} />
                            Code
                        </a>
                    </div>
                </div>
            </div>

        </MainLayout >
    )
}

export default Detail;
